module.exports = __webpack_public_path__ + "static/media/AR.ae8c2c63.svg";